jQuery(document).ready(function(){

    if(jQuery("#homepage-press").length > 0) {
  
      var totalSlides = jQuery('#homepage-press .slidegrid').length;
    
      jQuery('#homepage-press .slidegrid').slick(
        {
          slidesToScroll: 1,
          slidesToShow: 1,
          infinite: false,
          prevArrow: '#homepage-press .slide-navigation .cslick-prev',
          nextArrow: '#homepage-press .slide-navigation .cslick-next',
          appendDots: '#homepage-press .slide-navigation .dots',
          responsive: [{
            breakpoint: 800,
            settings: {
              dots: true            
            }
          }]
        }
      );
  
      jQuery('#homepage-press .slidegrid').on('afterChange', function(event, slick, currentSlide){
        if(currentSlide >= totalSlides) {
          jQuery('#homepage-press .slidegrid').slick('slickGoTo',0);
        }
      });   
    }

    if(jQuery("#productpage-press").length > 0) {
        
        jQuery('#productpage-press .slidegrid').slick(
          {
            slidesToScroll: 1,
            slidesToShow: 1,
            infinite: true,
            prevArrow: '#productpage-press .cslick-prev',
            nextArrow: '#productpage-press .cslick-next',
            responsive: [{
            breakpoint: 800,
            settings: {
              dots: true,
              arrows: false
            }
          }]
          }
        );            
      }

    if(jQuery("#productpage-banner").length > 0) {  
      if(!isMobile()) {
        jQuery(document).bind('mousewheel', function(e){
          if(e.originalEvent.wheelDelta / 120 > 0) {
              var windowPosition = jQuery(document).scrollTop();
              var bannerPosition = jQuery("#productpage-banner").scrollTop();
              var imageWidth = parseInt(jQuery("#productpage-banner .imageblock").width());  
              var documentWidth = parseInt(jQuery(document).width());

              if(windowPosition <= bannerPosition && imageWidth > (documentWidth / 2)) {                 
                 jQuery("#productpage-banner .imageblock").width(((imageWidth / documentWidth * 100) - 2) + "%"); 
                 //jQuery(document).scrollTop(bannerPosition);
              } 
          }
          else {
              var windowPosition = jQuery(document).scrollTop();
              var bannerPosition = jQuery("#productpage-banner").scrollTop();
              var imageWidth = parseInt(jQuery("#productpage-banner .imageblock").width());  
              var documentWidth = parseInt(jQuery(document).width());

              if(windowPosition >= bannerPosition && imageWidth < documentWidth) {
                 jQuery("#productpage-banner .imageblock").width(((imageWidth / documentWidth * 100) + 2) + "%"); 
                 jQuery(document).scrollTop(bannerPosition);
              }              
          }
        });
      }      
    }

    if(jQuery("div.accordion-content").length > 0 && !isMobile()) {
      jQuery("div.accordion-content h4").click(function(){
        var top = this;
        
        jQuery("div.accordion-content .accitem").each(function(){
          if(!jQuery(this).is(top)) {
            if(jQuery(this).is(".opened")) {
              jQuery(this).removeClass("opened");
              jQuery(this).find("p").slideUp();
            }
          }
        });
        
        if(jQuery(this).parent().is(".opened")) {
            jQuery(this).parent().removeClass("opened");
            jQuery(this).next().slideUp();
        } else {
          jQuery(this).parent().addClass("opened");
          jQuery(this).next().slideDown();
        }    
      });
      
    }

    if(parseInt(jQuery(document).width()) <= 750) {
        var div = jQuery("div.emptygrid.footer-block.grid__item").clone().html('').addClass("dynamicelement");
        var divContent = jQuery("<div></div>").addClass("footer-block__details-content").addClass("rte");
        jQuery(divContent).appendTo(div);
        jQuery(div).removeClass("emptygrid");
        jQuery(".footer-block.grid__item .footer-block__details-content p").appendTo(divContent);
        jQuery(div).appendTo(jQuery(".footer__blocks-wrapper.grid"));
      
        jQuery("h2.footer-block__heading.inline-richtext").click(function(){
          if(jQuery(this).is(".opened")) {
            jQuery(this).removeClass("opened");
            jQuery(this).next().slideUp();
          } else {
            jQuery(this).addClass("opened");
            jQuery(this).next().slideDown();
          }
        });
    }
});

function isMobile() {
  if(parseInt(jQuery(document).width()) <= 800) {
    return true;
  }

  return false;
}